import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";

export class UserCompanyList extends ListStoreConstructor<any> {
  id: string = "";

  setId(id: string) {
    this.id = id;
  }

  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getAllCompaniesByUserId({ userId: this.id }, params).then((response) => ({
          content: response.content || [],
          size: response.size || 0,
          totalPages: response.totalPages || 0,
          totalElements: response.totalElements || 0,
        }));
      },
      {
        pollingInterval: 10000,
      }
    );
  }
}
